module.exports = __webpack_public_path__ + "static/media/Cart-Icon-White.e4f61bbd.svg";